import Container from '@modules/common/components/container';

/**
 * Account Page Skeleton
 *
 * Loading skeleton for account pages
 */
export function AccountPageSkeleton() {
  return (
    <div className="small:py-8 flex-1" data-testid="account-skeleton">
      <Container className="flex h-full flex-1 flex-col bg-white">
        <div className="small:grid-cols-[240px_1fr] grid grid-cols-1 lg:py-8">
          {/* Sidebar skeleton */}
          <div className="mb-6 mr-6 w-full animate-pulse rounded-md border px-2 py-2 lg:w-auto">
            <div className="px-2 py-3">
              <div className="mb-1 h-3 w-20 rounded bg-gray-200" />
              <div className="h-4 w-32 rounded bg-gray-200" />
            </div>
            <div className="my-4 h-px bg-gray-200" />
            <div className="space-y-3 py-2">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="flex items-center gap-2 px-2">
                  <div className="h-5 w-5 rounded bg-gray-200" />
                  <div className="h-4 w-24 rounded bg-gray-200" />
                </div>
              ))}
            </div>
          </div>

          {/* Content skeleton */}
          <div className="animate-pulse space-y-4">
            <div className="h-8 w-48 rounded bg-gray-200" />
            <div className="h-4 w-full max-w-md rounded bg-gray-200" />
            <div className="h-4 w-full max-w-sm rounded bg-gray-200" />
          </div>
        </div>
      </Container>
    </div>
  );
}
